<script setup>
defineProps({
  keyGroups: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    default: ""
  },
  hideButton: {
    type: Boolean,
    default: false
  }
});
const isOpen = defineModel({ type: Boolean, ...{
  required: true
} });
const closeModal = () => {
  isOpen.value = false;
};
</script>

<template>
    <div v-if="!hideButton" class="p-2 z-50 bottom-0 right-0">
        <button
            class="h-10 w-10 bg-white p-1 shadow border border-opacity-20 border-black rounded-lg hover:bg-gray-100"
            :aria-label="title"
            @click="isOpen = true"
        >
            <IconInfoCircle class="size-5 mx-auto my-auto text-slate-500" />
        </button>
    </div>
    <ChargemapModal
        v-if="isOpen"
        size="xs"
        show-x
        no-scroll
        block-outer-scroll
        text-center
        @updateIsVisible="closeModal"
        @clickedOutside="closeModal"
    >
        <div class="flex flex-col max-h-full gap-6">
            <span
                class="text-slate-800 text-lg font-semibold leading-7 text-center"
            >
                {{ title }}
            </span>
            <div class="flex flex-col w-full gap-6 overflow-auto">
                <div
                    v-for="(group, groupIndex) in keyGroups"
                    :key="groupIndex"
                    class="flex flex-col items-center justify-center"
                    :class="groupIndex !== keyGroups.length - 1 && 'mb-6'"
                >
                    <span
                        class="text-header-dark text-[14px] font-medium pb-4 px-1 py-1 uppercase leading-[12px] tracking-[0.84px]"
                    >
                        {{ group.title }}
                    </span>

                    <div
                        class="w-full border border-secondary-gray-disabled rounded-lg"
                    >
                        <div
                            v-for="(item, itemIndex) in group.items"
                            :key="itemIndex"
                            class="flex flex-col"
                        >
                            <div
                                class="flex flex-row gap-2 py-3 px-4 items-center"
                            >
                                <div class="flex justify-center items-center">
                                    <div
                                        v-for="(icon, iconIndex) in item.icons"
                                        :key="iconIndex"
                                    >
                                        <NuxtImg
                                            :src="icon"
                                            class="w-[30px] h-8"
                                            :alt="`${item.title}_${iconIndex}`"
                                        />
                                    </div>
                                </div>

                                <div
                                    class="flex justify-center items-center gap-1"
                                >
                                    <span
                                        class="text-gray-l-800 text-[15px] leading-[18px] font-normal"
                                    >
                                        {{ item.title }}
                                    </span>
                                    <span
                                        v-if="item.subtitle"
                                        class="text-gray-l-500 text-[13px] leading-[16px] font-normal"
                                    >
                                        {{ item.subtitle }}
                                    </span>
                                </div>
                            </div>

                            <div
                                v-if="itemIndex < group.items.length - 1"
                                class="border-t border-secondary-gray-disabled ml-4"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <ChargemapB2CButton
                type="secondary"
                class="w-full"
                @click="closeModal"
            >
                <span class="uppercase">
                    {{ $t("ok") }}
                </span>
            </ChargemapB2CButton>
        </div>
    </ChargemapModal>
</template>
